import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Download, Mail, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { API } from "@/utils/constants";

export const NewsletterSubscribersView = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/newsletter`).then((r) => setData(r.data)).catch(() => { toast.error("Failed to load subscribers"); setData({ total: 0, subscribers: [] }); });
  }, []);

  const exportCsv = () => {
    const rows = [["email", "subscribed_at"], ...data.subscribers.map((s) => [s.email, s.created_at || ""])];
    const csv = rows.map((r) => r.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `newsletter-subscribers-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(a.href);
  };

  if (!data) return <div className="p-6 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>;

  return (
    <div className="p-4 sm:p-6" data-testid="newsletter-subscribers-view">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Mail className="h-4 w-4 text-primary" />
          <span className="font-semibold text-sm">{data.total} subscriber{data.total === 1 ? "" : "s"}</span>
        </div>
        <Button size="sm" variant="outline" onClick={exportCsv} disabled={data.total === 0} data-testid="newsletter-export-btn">
          <Download className="h-4 w-4 mr-1.5" />Export CSV
        </Button>
      </div>
      {data.total === 0 ? (
        <p className="text-sm text-muted-foreground text-center py-10">No subscribers yet — the signup form lives in your website footer.</p>
      ) : (
        <div className="border rounded-xl overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-muted/50">
              <tr><th className="text-left p-3 font-medium">Email</th><th className="text-left p-3 font-medium">Subscribed</th></tr>
            </thead>
            <tbody>
              {data.subscribers.map((s) => (
                <tr key={s.email} className="border-t" data-testid={`subscriber-row-${s.email}`}>
                  <td className="p-3">{s.email}</td>
                  <td className="p-3 text-muted-foreground">{s.created_at ? new Date(s.created_at).toLocaleDateString() : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
